module.exports = __webpack_public_path__ + "static/media/basketball.c725ad92.jpg";